import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { EDUCATION_LEVELS } from '@/lib/education-levels';

interface EducationLevelRadioGroupProps {
  value: string;
  onChange: (value: string) => void;
}

export function EducationLevelRadioGroup({ value, onChange }: EducationLevelRadioGroupProps) {
  return (
    <RadioGroup value={value} onValueChange={onChange} className="grid grid-cols-4 gap-2">
      {EDUCATION_LEVELS.map((level) => (
        <div key={level.value} className="flex items-center space-x-2">
          <RadioGroupItem value={level.value} id={`level-${level.value}`} />
          <Label htmlFor={`level-${level.value}`} className="text-sm cursor-pointer">
            {level.value}
          </Label>
        </div>
      ))}
    </RadioGroup>
  );
}
